frappe.ui.form.ControlImage = class ControlImage extends frappe.ui.form.Control {
	make() {
		super.make();
		this.$wrapper.css({ margin: "0px" });
		this.$body = $("<div></div>").appendTo(this.$wrapper).css({ "margin-bottom": "10px" });
		$('<div class="clearfix"></div>').appendTo(this.$wrapper);
	}
	// refresh_input() {
	// 	this.$body.empty();

	// 	var doc = this.get_doc();
	// 	if (doc && this.df.options && doc[this.df.options]) {
	// 		this.$img = $(
	// 			"<img src='" + doc[this.df.options] + "' class='img-responsive'>"
	// 		).appendTo(this.$body);
	// 	} else if (doc && this.df.options) {
	// 		this.$img = $(
	// 			"<img src='" + this.df.options + "' class='img-responsive'>"
	// 		).appendTo(this.$body);
	// 	} else {
	// 		this.$buffer = $(
	// 			`<div class='missing-image'>${frappe.utils.icon("restriction", "md")}</div>`
	// 		).appendTo(this.$body);
	// 	}
	// 	return false;
	// }
	refresh_input() {
		this.$body.empty();

		const doc = this.get_doc();
		const url_from_doc = doc && this.df.options && doc[this.df.options];
		const static_url = this.df.options;

		const show_image = (src) => {
			this.$img = $("<img>", {
				src,
				class: "img-responsive"
			}).appendTo(this.$body);
		};

		const show_fallback = () => {
			this.$buffer = $(
				`<div class='missing-image'>${frappe.utils.icon("restriction", "md")}</div>`
			).appendTo(this.$body);
		};

		// Priority: Doc-based image > fallback to static URL
		if (url_from_doc) {
			show_image(url_from_doc);
		} else if (static_url) {
			// Validate if static_url actually loads
			const test_img = new Image();
			test_img.onload = () => show_image(static_url);
			test_img.onerror = show_fallback;
			test_img.src = static_url;
		} else {
			show_fallback();
		}

		return false;
	}
};
